// extracted by mini-css-extract-plugin
module.exports = {"spacing":"Row_spacing__jaN0W"};